import { render, staticRenderFns } from "./RecipeHistory.vue?vue&type=template&id=1fffccaf&scoped=true"
import script from "./RecipeHistory.vue?vue&type=script&lang=js"
export * from "./RecipeHistory.vue?vue&type=script&lang=js"
import style0 from "./RecipeHistory.vue?vue&type=style&index=0&id=1fffccaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fffccaf",
  null
  
)

export default component.exports